import { render } from "./Charges.vue?vue&type=template&id=af1afb40"
import script from "./Charges.vue?vue&type=script&lang=js"
export * from "./Charges.vue?vue&type=script&lang=js"

import exportComponent from "/home/netvib01/domains/hr.ibeo.nl.netvibestest.net/ibeo-hr-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__